const getDefaultState = () => {
    return {
        operationId: null,
        boxHello: {
            text: '',
            scenarioId: ''
        }
    }
}
// initial state
const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setBoxHelloText(state, text) {
            state.boxHello.text = text
        },
        setBoxHelloScenarioId(state, id) {
            state.boxHello.scenarioId = id
        },
        setOperationId(state, operationId) {
            state.operationId = operationId
        }
        /*   addEvent(state, val) {
            state.eventList.push(val)
        }*/
    },
    actions: {
        /* pushEvent({ rootState, state, commit, dispatch }, { name, group }) {
            commit('addEvent', { name, group })
        }*/
    },
    getters: {
        /* eventListAll: state => {
            return state.eventList
        }*/
    }
}
